import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();

  useEffect(() => {
    const email = searchParams.get('email');

    if (email) {
      // Cookie is set by the server redirect. Fetch full user profile
      // (including role, status, departments) from /api/auth/me.
      api.get('/auth/me')
        .then(userData => {
          login(null, userData);
          navigate('/dashboard', { replace: true });
        })
        .catch(() => {
          // If /me fails, try with just the URL params as fallback
          const name = searchParams.get('name');
          login(null, { name, email });
          navigate('/dashboard', { replace: true });
        });
    } else {
      navigate('/login?error=missing_token', { replace: true });
    }
  }, [searchParams, login, navigate]);

  return null; // Brief flash -- redirects immediately
}

export default AuthCallback;
